import { useLocation } from "react-router-dom";
import { Container, Typography } from "@mui/material";
import { useEffect } from "react";
type Props = {};

const ImageTitles = (props: Props) => {
  const { pathname } = useLocation();
  const pathArray: Array<string> = pathname.split("/");
  let currentPath = "";
  if (pathArray.length === 3) {
    currentPath = pathArray[2];
  } else if (pathArray.length === 2) {
    if (pathArray[1].length === 0) {
      currentPath = "home";
    } else {
      currentPath = pathArray[1];
    }
  }

  if (currentPath.includes("-")) {
    let newPath = currentPath.split("-").map((index, i) => {
      return index[0].toUpperCase() + index.slice(1);
    });
    currentPath = newPath.join(" ");
  }
  useEffect(() => {}, [currentPath]);
  return (
    <>
      {currentPath === "home" ? (
        <></>
      ) : (
        <Container
          sx={{
            backgroundColor: "customColors.clr1",
            // backgroundImage: "black",
            // backgroundRepeat: "no-repeat",
            // backgroundSize: "100% 100%",
            minHeight: "17vh",
            minWidth: "100%",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {currentPath.length > 0 && (
            <>
              {currentPath.includes("-") ? (
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "inherit",
                    fontSize: "3rem",
                    textAlign: "center",
                  }}
                >
                  {currentPath}
                </Typography>
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "inherit",
                    fontSize: "3rem",
                    textAlign: "center",
                  }}
                >
                  {currentPath[0].toUpperCase() + currentPath.slice(1)}
                </Typography>
              )}
            </>
          )}
        </Container>
      )}
    </>
  );
};

export default ImageTitles;
